import React from 'react';
import * as StockUtil from '../../Utils/StockUtil';
import {prependTwoZero} from '../../Utils/TimeUtil';

export default function AdminProductStockSummary(props) {
  const {record} = props;

  const formatDateTimeDisplay = (date) => {
    return `${date.getFullYear()}-${prependTwoZero(
      date.getMonth() + 1,
    )}-${prependTwoZero(date.getDate())} ${prependTwoZero(
      date.getHours(),
    )}:${prependTwoZero(date.getMinutes())}:${prependTwoZero(
      date.getSeconds(),
    )}`;
  };

  if (!record.stock_type || record.stock_type === 'always') {
    return '常備';
  } else if (record.stock_type === 'total') {
    return '總量';
  } else if (record.stock_type === 'period') {
    const [startDate, endDate] = StockUtil.getStartEndDate(record);
    if (!startDate || !endDate) {
      return `期間設定有誤`;
    } else {
      return (
        <div>
          <div>期間</div>
          <div>{formatDateTimeDisplay(startDate)}</div>
          <div>{formatDateTimeDisplay(endDate)}</div>
        </div>
      );
    }
  }

  return '---';
}
